import React, { Component } from 'react';
import {
    Grid,
    Col,
    Row,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// CSS
import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Login.css';
import brandingStyles from '../branding/brandingStyles';

// To handle requests
import UsersAPI from '../utils/UsersAPI';

// Form Validation
import Validation from 'react-validation';

// Images
const config = require('../branding/branding.json');
let logo;
if (!config.logoExternal) {
    logo = require(`../${config.logoUrl}`);
} else {
    logo = config.logoUrl;
}

function saveCredentials(credentials, username, type) {
    localStorage.setItem('scality-credentials',
        JSON.stringify(credentials));
    localStorage.setItem('scality-username',
        JSON.stringify(username));
    localStorage.setItem('scality-usertype',
        JSON.stringify(type));
}

// Small stateless component to display errors
const ErrorTag = ({ match }) => {
    let errorText;
    if (match && match.params.type) {
        switch (match.params.type) {
        case 'invalidkey':
            errorText = 'Could not login. Invalid IAM Key.';
            break;
        case '401':
            errorText = 'Authentication issue. Please try again.';
            break;
        case '403':
            errorText = 'Session expired. Please try logging in again';
            break;

        default:
            errorText = 'An error occured, please contact your Administrator';
        }
    }
    return (
      <div className="alert alert-warning">
          {errorText}
      </div>
    );
};
ErrorTag.propTypes = {
    match: PropTypes.object.isRequired,
};

class Login extends Component {

    constructor() {
        super();
        this.state = {
            username: '',
            password: '',
            error: '',
        };
        this.submit = this.submit.bind(this);
    }

    // Handle form change
    handleChange(name, e) {
        const change = {};
        change[name] = e.target.value;
        this.setState(change);
    }


    componentWillMount() {
        // Setting validation rules for login form validation
        Object.assign(Validation.rules, {
            // Key name maps the rule
            required: {
                rule: value => (value.trim().length),
                hint: () => (
                    <span className="form-error is-visible">
                        This field is required
                    </span>
                ),
            },
        });
    }

    submit(e) {
        e.preventDefault();

        UsersAPI.login(this.state.username,
          this.state.password).then(res => {
              if (!res.token) {
                  return this.setState({
                      error: 'Wrong credentials. Please try again.',
                  });
              }
              // Saving JSON Web Token and user type
              // in localstorage for further requests
              saveCredentials(res.token, this.state.username, res.type);
              // Redirecting to corresponding view
              if (res.type === 'superadmin') {
                  this.setState({ authenticated: true, admin: true });
              } else {
                  this.setState({ authenticated: true });
              }
              return 0;
          });
    }

    render() {
        const biggerIconsStyle = {
            fontSize: '20px',
        };

        if (this.state.authenticated) {
            if (this.state.admin) {
                return (<Redirect to="/accounts" />);
            }
            return (<Redirect to="/users" />);
        }

        return (
            <div style={Object.assign(
                { height: '100vh' },
                brandingStyles.backgrounds.main
              )}>
                <Row className="head-row">
                    <img src={logo} style={{
                        width: '30%',
                        minWidth: '300px',
                    }} alt="Logo"/>
                  <h3 className="logo-text">S3 CONSOLE</h3>
                </Row>
                <Grid>
                    <Row className="vertical-flex">
                        <Col
                          xs={10}
                          xsOffset={1}
                          md={6}
                          mdOffset={3}
                          className="login-box"
                          style={brandingStyles.backgrounds.panel}
                        >
                            <Validation.components.Form>

                                <div className="form-group">
                                    <label>
                                        <i className="fa fa-key"
                                          style={biggerIconsStyle}></i>
                                        <span>&nbsp;</span>
                                        USERNAME</label>
                                    <Validation.components.Input
                                      autoFocus
                                      className="form-control full-width"
                                      style={brandingStyles.backgrounds.input}
                                      value={this.state.username}
                                      onChange={
                                        this.handleChange.bind(this,
                                           'username')
                                         }
                                      placeholder="Username"
                                      name="username"
                                      validations={['required']}/>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <i className="fa fa-lock"
                                          style={biggerIconsStyle}></i>
                                        <span>&nbsp;</span>
                                        PASSWORD
                                    </label>
                                    <Validation.components.Input
                                      className="form-control full-width"
                                      style={brandingStyles.backgrounds.input}
                                      type="password"
                                      value={this.state.password}
                                      onChange={this.handleChange.bind(this,
                                        'password')}
                                      placeholder="Password"
                                      name="password"
                                      validations={['required']}/>
                                </div>

                                {
                                  this.state.error.length ?
                                  (
                                    <div className="alert alert-warning">
                                      {this.state.error}
                                    </div>
                                  )
                                  : (
                                    <Route
                                      path=
                                      {`${this.props.match.url}/error/:type`}
                                      component={ErrorTag}
                                    />
                                  )
                                }

                                <Validation.components.Button
                                  onClick={this.submit}
                                  className="btn btn-primary btn-block"
                                  style={brandingStyles.buttons.primary}
                                >
                                    Submit
                                </Validation.components.Button>

                            </Validation.components.Form>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

Login.propTypes = {
    match: PropTypes.object,
};

export default Login;



/** WEBPACK FOOTER **
 ** ./src/pages/Login.js
 **/